import Lottie from "lottie-react";
import React, { useEffect } from "react";
import Loading from "../../../assets/images/gif/sdap-loading.json";
import { ROUTES } from "../../../configs/routes";
import { useAuthProvider } from "../../../hooks/useAuthProvider";
import "./DigitalLegacyAuth.scss";

export const DigitalLegacyAuth: React.FC = () => {
	const { login } = useAuthProvider();

	useEffect(() => {
		login("DL", { redirectURL: ROUTES.MYDATA, isDigitalLegacy: true });
	}, []);

	return (
		<Lottie
			className="dl-route__loading"
			animationData={Loading}
			loop={true}
			style={{ width: 60, height: 60 }}
		/>
	);
};

export default DigitalLegacyAuth;
